"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModelMetadata = exports.IkeCalcVersion = void 0;
const core_api_1 = require("@ikegps/core-api");
var IkeCalcVersion;
(function (IkeCalcVersion) {
    /** v0.2.0 - Span / Circuit / Wire */
    IkeCalcVersion[IkeCalcVersion["V0_2_0"] = 512] = "V0_2_0";
    /** v0.2.1 - Span / Circuit / Wire with span-guy mid-span height and WEP height */
    IkeCalcVersion[IkeCalcVersion["V0_2_1"] = 513] = "V0_2_1";
    /** v0.3.0 - Span / Wire */
    IkeCalcVersion[IkeCalcVersion["V0_3_0"] = 768] = "V0_3_0";
})(IkeCalcVersion || (exports.IkeCalcVersion = IkeCalcVersion = {}));
/**
 * Set a value based of a dot seperated string,
 * eg set('a.b.c', 'value') => { 'a' : { 'b': { 'c': 'value' } } }
 */
const setDotString = (obj, key, value) => {
    var keys = key.split('.');
    var curObj = obj;
    for (var i = 0; i < keys.length - 1; i++) {
        var curKey = keys[i];
        var val = curObj[curKey];
        if (val == null) {
            curObj = curObj[curKey] = {};
        }
        else {
            curObj = val;
        }
    }
    var lastKey = keys[keys.length - 1];
    curObj[lastKey] = value;
};
class FormModelMetadata {
    constructor(form) {
        this.options = {};
        this.statusFieldId = null;
        this.mapColorFieldId = null;
        this.addressLookupFieldId = null;
        this.form = form;
    }
    setImportType(type, version) {
        this.import = { type, version };
    }
    setMapColorField(field) {
        if (!field) {
            this.mapColorFieldId = null;
            return;
        }
        if (field.type !== core_api_1.IkeFieldType.NESTED_LIST && field.type !== core_api_1.IkeFieldType.SELECT_LIST) {
            throw new Error(`Map color field: "${field.type}" is not a "${core_api_1.IkeFieldType.NESTED_LIST}" nor a "${core_api_1.IkeFieldType.SELECT_LIST}"`);
        }
        this.mapColorFieldId = field.id;
    }
    removeMapColorField(field) {
        if (!field) {
            this.mapColorFieldId = null;
        }
        else if (field.id === this.mapColorFieldId) {
            this.mapColorFieldId = null;
        }
    }
    getMapColorField() {
        if (this.mapColorFieldId == null) {
            return null;
        }
        return this.form.getField(this.mapColorFieldId);
    }
    setStatusField(field) {
        if (!field) {
            this.statusFieldId = null;
            return;
        }
        if (field.type !== core_api_1.IkeFieldType.NESTED_LIST && field.type !== core_api_1.IkeFieldType.SELECT_LIST) {
            throw new Error(`Status field: "${field.type}" is not a "${core_api_1.IkeFieldType.NESTED_LIST}" nor a "${core_api_1.IkeFieldType.SELECT_LIST}"`);
        }
        this.statusFieldId = field.id;
    }
    removeStatusField(field) {
        if (!field) {
            this.statusFieldId = null;
        }
        else if (field.id === this.statusFieldId) {
            this.statusFieldId = null;
        }
    }
    getStatusField() {
        if (this.statusFieldId == null) {
            return null;
        }
        return this.form.getField(this.statusFieldId);
    }
    setOption(key, value) {
        setDotString(this.options, key, value);
    }
    setAddressLookupField(field) {
        if (!field) {
            this.addressLookupFieldId = null;
            return;
        }
        this.addressLookupFieldId = field.id;
    }
    removeAddressLookupField(field) {
        if (!field) {
            this.addressLookupFieldId = null;
            return;
        }
        if ((field === null || field === void 0 ? void 0 : field.id) === this.addressLookupFieldId) {
            this.addressLookupFieldId = null;
        }
    }
    getAddressLookupField() {
        if (this.addressLookupFieldId == null) {
            return null;
        }
        return this.form.getField(this.addressLookupFieldId);
    }
    isPLAForm() {
        return Boolean(this.options.ocalc ||
            this.options.spidacalc ||
            this.options.poleforeman ||
            this.options.ikePoleForeman ||
            this.options.dds);
    }
    getIkePoleForeman() {
        var _a, _b;
        return (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.ikePoleForeman) !== null && _b !== void 0 ? _b : null;
    }
    isIkePoleForeman() {
        return !!this.getIkePoleForeman();
    }
}
exports.FormModelMetadata = FormModelMetadata;
//# sourceMappingURL=form.metadata.js.map